import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import { labelStyles } from '../Label/styles';

export const DivStyled = styled.div`
  ${labelStyles}
`;

export const FieldsetStyled = styled.fieldset`
  margin-top: ${rem(4)};
`;

export const RadioLabelStyled = styled.span`
  margin-right: ${rem(8)};
`;

export const RadioLabelGroupStyled = styled.label`
  ${({ index }) => css`
    ${index > 0 && 'margin-left: 1rem;'}
  `}
`;
